import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();
export const applicationInsights = new ApplicationInsights({
    config: {
        instrumentationKey: '7090f7bd-9768-4587-be50-03843c554310',
        enableAutoRouteTracking: true,
        extensions: [reactPlugin],
    },
});
applicationInsights.loadAppInsights();

export default (Component) => withAITracking(reactPlugin, Component);
